import script from "./Tooling.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tooling.vue?vue&type=script&setup=true&lang=ts"

import "./Tooling.vue?vue&type=style&index=0&id=5bac09f9&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bac09f9"]])

export default __exports__